import React, { Component } from 'react';
import { string, func } from 'prop-types';
import { translate } from 'react-i18next';
import { compose } from 'redux';

import { getVideoUrl } from '@blueberry/utils/youtube';

import styles from './VideoBlock.scss';

class VideoBlock extends Component {
  static propTypes = {
    mediaEmbedUrl: string.isRequired,
    t: func.isRequired,
  };

  renderVideo() {
    const { mediaEmbedUrl } = this.props;
    const config = {
      enablejsapi: 1,
      rel: 0,
      showinfo: 0,
    };
    const url = getVideoUrl(config)(mediaEmbedUrl);

    return (
      <div className={styles.video}>
        <iframe scrolling="no" src={url} />
      </div>
    );
  }

  render() {
    return this.renderVideo();
  }
}

export default compose(translate(['content', 'login']))(VideoBlock);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/VideoPostContent/components/VideoBlock/VideoBlock.jsx